import React, { useState, useRef } from 'react';
import { MapPin, DollarSign, ChevronLeft, ChevronRight, Download } from 'lucide-react';
const jobs = [{
  id: 1,
  title: 'Marine Engineer',
  type: 'Oil Tanker / VLCC',
  location: 'Middle East',
  salary: 'from $4500',
  description: 'Experienced marine engineer needed for VLCC operations. Responsible for main engine maintenance, troubleshooting, and ensuring compliance with safety regulations.'
}, {
  id: 2,
  title: 'Chief Officer',
  type: 'Container Vessel',
  location: 'Europe',
  salary: 'from $5500',
  description: 'Seeking qualified Chief Officer for container vessel operations. Responsibilities include cargo operations, navigation, safety management, and crew supervision.'
}, {
  id: 3,
  title: 'Electrical Engineer',
  type: 'Offshore Platform',
  location: 'North Sea',
  salary: 'from $6000',
  description: 'Electrical engineer position available for offshore platform. Maintain and repair electrical systems, power generation equipment, and control systems.'
}, {
  id: 4,
  title: 'Deck Cadet',
  type: 'Bulk Carrier',
  location: 'Asia Pacific',
  salary: 'from $2000',
  description: 'Entry-level position for deck cadet on bulk carrier. Training opportunity for maritime academy graduates.'
}, {
  id: 5,
  title: 'Second Engineer',
  type: 'LNG Carrier',
  location: 'Global',
  salary: 'from $5000',
  description: 'Second Engineer required for LNG carrier operations. Manage engine room operations, maintenance schedules, and technical documentation.'
}, {
  id: 6,
  title: 'Bosun',
  type: 'Cruise Ship',
  location: 'Caribbean',
  salary: 'from $3200',
  description: 'Experienced Bosun needed for luxury cruise operations. Lead deck crew, coordinate maintenance activities.'
}, {
  id: 7,
  title: 'Marine Superintendent',
  type: 'Fleet Management',
  location: 'Singapore',
  salary: 'from $7000',
  description: 'Shore-based Marine Superintendent position. Oversee technical operations of vessel fleet, conduct inspections.'
}, {
  id: 8,
  title: 'QHSE Manager',
  type: 'Offshore Installation',
  location: 'Middle East',
  salary: 'from $6500',
  description: 'Quality, Health, Safety & Environment Manager for offshore operations. Develop and implement QHSE policies.'
}, {
  id: 9,
  title: 'AB Seaman',
  type: 'General Cargo',
  location: 'Mediterranean',
  salary: 'from $2500',
  description: 'Able Bodied Seaman position on general cargo vessel. Perform deck maintenance, cargo operations, and watchkeeping duties.'
}, {
  id: 10,
  title: 'Chief Engineer',
  type: 'Chemical Tanker',
  location: 'Europe',
  salary: 'from $7500',
  description: 'Chief Engineer position for chemical tanker operations. Overall responsibility for engine room and maintenance planning.'
}, {
  id: 11,
  title: 'Radio Officer',
  type: 'Research Vessel',
  location: 'Antarctica',
  salary: 'from $4000',
  description: 'Radio Officer needed for scientific research vessel. Maintain communication systems and support research operations.'
}, {
  id: 12,
  title: 'Pumpman',
  type: 'Product Tanker',
  location: 'Asia',
  salary: 'from $3500',
  description: 'Experienced Pumpman for product tanker operations. Responsible for cargo pumping systems and tank cleaning.'
}, {
  id: 13,
  title: 'DPO',
  type: 'Offshore Support Vessel',
  location: 'West Africa',
  salary: 'from $5500',
  description: 'Dynamic Positioning Operator for OSV operations. Operate DP systems during offshore operations.'
}, {
  id: 14,
  title: 'Crane Operator',
  type: 'Heavy Lift Vessel',
  location: 'Global',
  salary: 'from $4500',
  description: 'Certified crane operator for heavy lift vessel. Operate deck cranes for cargo operations.'
}, {
  id: 15,
  title: 'Catering Manager',
  type: 'Passenger Ferry',
  location: 'Scandinavia',
  salary: 'from $3800',
  description: 'Catering Manager for passenger ferry operations. Manage galley operations, food service, and inventory.'
}];
export function JobVacancies() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const scroll = (direction: 'left' | 'right') => {
    if (scrollContainerRef.current) {
      const cardWidth = scrollContainerRef.current.offsetWidth / 3;
      const scrollAmount = direction === 'left' ? -cardWidth : cardWidth;
      scrollContainerRef.current.scrollBy({
        left: scrollAmount,
        behavior: 'smooth'
      });
      if (direction === 'left' && currentIndex > 0) {
        setCurrentIndex(currentIndex - 1);
      } else if (direction === 'right' && currentIndex < jobs.length - 3) {
        setCurrentIndex(currentIndex + 1);
      }
    }
  };
  return <section className="w-full py-16 px-6 md:px-12 bg-[var(--color-bg)]" data-id="element-212">
      <div className="max-w-7xl mx-auto" data-id="element-213">
        {/* Header */}
        <div className="flex items-center justify-between mb-8" data-id="element-214">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 border border-gray-200 rounded-full bg-white" data-id="element-215">
            <span className="text-sm font-medium text-[var(--color-text-dark)]" data-id="element-216">
              Vacancies
            </span>
          </div>

          {/* Navigation arrows */}
          <div className="flex gap-2" data-id="element-217">
            <button onClick={() => scroll('left')} disabled={currentIndex === 0} className="w-10 h-10 rounded-full border border-gray-200 bg-white flex items-center justify-center hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors" data-id="element-218">
              <ChevronLeft className="w-5 h-5" data-id="element-219" />
            </button>
            <button onClick={() => scroll('right')} disabled={currentIndex >= jobs.length - 3} className="w-10 h-10 rounded-full border border-gray-200 bg-white flex items-center justify-center hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors" data-id="element-220">
              <ChevronRight className="w-5 h-5" data-id="element-221" />
            </button>
          </div>
        </div>

        {/* Horizontal Scrolling Container */}
        <div ref={scrollContainerRef} className="flex gap-6 overflow-x-auto scrollbar-hide snap-x snap-mandatory" style={{
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
      }} data-id="element-222">
          {jobs.map(job => <div key={job.id} className="flex-shrink-0 w-full md:w-[calc(33.333%-16px)] bg-white rounded-xl p-6 border border-gray-100 snap-start" data-id="element-223">
              <h3 className="text-lg font-semibold text-[var(--color-text-dark)] mb-1" data-id="element-224">
                {job.title}
              </h3>
              <p className="text-sm text-[var(--color-text-light)] mb-4" data-id="element-225">
                {job.type}
              </p>

              <div className="flex items-center gap-4 mb-4" data-id="element-226">
                <div className="flex items-center gap-1.5 text-sm text-[var(--color-text-light)]" data-id="element-227">
                  <MapPin className="w-4 h-4" data-id="element-228" />
                  <span data-id="element-229">{job.location}</span>
                </div>
                <div className="flex items-center gap-1.5 text-sm text-[var(--color-text-light)]" data-id="element-230">
                  <DollarSign className="w-4 h-4" data-id="element-231" />
                  <span data-id="element-232">{job.salary}</span>
                </div>
              </div>

              <p className="text-sm text-[var(--color-text-light)] mb-6 line-clamp-4" data-id="element-233">
                {job.description}
              </p>

              <button className="w-full flex items-center justify-center gap-2 px-4 py-3 bg-[var(--color-tan)] text-white text-sm font-medium rounded-lg hover:opacity-90 transition-opacity" data-id="element-234">
                Send resume
                <Download className="w-4 h-4" data-id="element-235" />
              </button>
            </div>)}
        </div>

        {/* Progress indicator */}
        <div className="flex justify-center mt-6 gap-2" data-id="element-236">
          {Array.from({
          length: Math.ceil(jobs.length / 3)
        }).map((_, index) => <button key={index} onClick={() => {
          setCurrentIndex(index * 3);
          if (scrollContainerRef.current) {
            const cardWidth = scrollContainerRef.current.offsetWidth / 3;
            scrollContainerRef.current.scrollTo({
              left: index * cardWidth * 3,
              behavior: 'smooth'
            });
          }
        }} className={`w-2 h-2 rounded-full transition-colors ${Math.floor(currentIndex / 3) === index ? 'bg-[var(--color-tan)]' : 'bg-gray-300'}`} data-id="element-237" />)}
        </div>
      </div>
    </section>;
}